import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["select", "wrapper", "input"];

  toggle() {
    const isOther = this.selectTarget.value === "-1";
    this.wrapperTarget.style.display = isOther ? "" : "none";
    if (!isOther) {
      this.inputTarget.value = "";
    }
  }
}
